<template>
  <div>
    <div class="modal-main-header">
      <h3 class="modal-header-changeType">{{  $t('users.form.user_type_changed') }}</h3>
    </div>

    <div class="modal-main-content">
      <span class="modal-msg" v-html="$t('users.form.user_type_success')"/>
    </div>
    <div class="line-divider"></div>
    <div class="d-flex align-items-center justify-content-center confirmation">
      <button
        @click="
          $bvModal.hide('change-user-type-massaction-success-message'),
            $emit('refreshGrid')
        "
        class="change-type"
      >
        {{ $t('common.okay') }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  onMounted() {
    this.$bvModal.hide("change-user-type-massaction");
  },
};
</script>

<style lang="scss">
div#change-user-type-massaction-success-message___BV_modal_content_ {
  width: 500px !important;
  border-radius: 26px !important;
  margin-top: 150px;
  .modal-main-header {
    .modal-header-changeType {
      color: #000;
      margin-bottom: 40px;
      font-size: 17px;
      text-align: center;
      font-weight: 700;
      line-height: normal;
    }
  }

  .modal-main-content {
    width: 416px;
    margin: auto;
    .modal-msg {
      color: #787878;
      text-align: left;
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
      letter-spacing: normal;
      
    }
  }

  .line-divider {
    height: 1px;
    background-color: #707070;
    opacity: 0.15;
    margin-top: 40px;
    margin-bottom: 24px;
  }
  .confirmation {
    margin: auto;
    button.change-type {
      width: 112px;
      height: 32px;
      color: #ffffff;

      background-color: #103f5e;

      border-radius: 26px;
      border: solid 1px #103f5e;
      text-align: center;

      font-size: 16px;

      font-weight: 400;
      line-height: normal;
    }
  }
}
</style>
